import { render, staticRenderFns } from "./AnnoncesSingleView.vue?vue&type=template&id=6c5a4ab8"
import script from "./AnnoncesSingleView.vue?vue&type=script&lang=js"
export * from "./AnnoncesSingleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports